import Button from 'Components/Button';
import ModalComponent from 'Components/Modal';
import PropTypes from 'prop-types';
import { useState } from 'react';
import ConversacionesService from 'Services/Http/Conversaciones.service';

const ValidacionFormulario = (props) => {
  const { idExpediente, type, estatusConversacion = 0 } = props;
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showComponent, setShowComponent] = useState(estatusConversacion);

  const enviarValidacion = () => {
    setShowModal(true);
  };

  const validacion = async () => {
    setLoading(true);
    setShowModal(false);
    try {
      await ConversacionesService.solicitarInicioConverasion(idExpediente, type);
      setShowComponent(true);
    } catch (e) {
      console.log(e);
    } finally {
      setShowModal(false);
      setLoading(false);
    }
  };

  return !showComponent ? (
    <div className="flex flex-col md:flex-row gap-3 my-3 md:grid md:grid-flow-col md:grid-cols-1 justify-stretch gap-3">
      <ModalComponent
        show={showModal}
        actionOK={validacion}
        typeModal={'decision'}
        changeState={setShowModal}
        title={'Se enviara la validacion al usuario, desea continuar?'}
      />
      <Button
        label={'Enviar Validacion'}
        color={'primary'}
        onClick={enviarValidacion}
        loading={loading}
      />
    </div>
  ) : null;
};

ValidacionFormulario.propTypes = {
  idExpediente: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  estatusConversacion: PropTypes.string.isRequired
};

export default ValidacionFormulario;
